import { connect } from 'react-redux';
import { setDoesAction, setStatus, setCompany } from '../../../actions/consultantActions';

// on importe le composant de présentation
import ConsultantFormInfos from '../../../components/InfosConsultantPage/ConsultantFormInfos';

// === mapStateToProps
// si on a besoin de lire des informations dans le state
const mapStateToProps = (state) => ({
  // nom de la prop à remplir: élément à récupérer dans le state
  currentConsultant: state.consultantReducer.currentConsultant,
});

// === mapDispatchToProps
// si on a besoin de dispatcher des actions vers le store (modifier le state)
const mapDispatchToProps = (dispatch) => ({
  // nom de la prop à remplir: fonction qui dispatch l'action
  handleDoesActionChange: (value) => {
    dispatch(setDoesAction(value));
  },
  handleStatusChange: (value) => {
    dispatch(setStatus(value));
  },
  handleCompanyChange: (value) => {
    dispatch(setCompany(value));
  },
});

// === création de l'assistant
export default connect(mapStateToProps, mapDispatchToProps)(ConsultantFormInfos);